export default __webpack_public_path__ + "static/media/sign_s.927417fe.png";